import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  analytics,
  getSearchOpenDetail,
  getNavigationOpenDetail,
} from '@/utils/analytics';

import Icon from '@/atoms/Icon/Icon';
import Button from '@/atoms/Button/Button';
import Text from '@/atoms/Text/Text';
import WestholmeLogo from '@/atoms/Logo/WestholmeLogo';
import DDLogo from '@/atoms/Logo/DDLogo';
import Search from '@/molecules/Search/Search';
import NavigationContent from '@/molecules/Navigation/Navigation';
import { CtaWrapper } from '@/molecules/CTA/index';

// @TODO: get basic navigation from contentful
function NavigationDefault({
  fields = [],
  entries = [],
  assets = [],
  hasBackground,
  hideLogo,
  isBlock,
  slug,
  tags,
}) {
  const [searchIsOpen, setSearchIsOpen] = useState(false);
  const [navigationIsOpen, setNavigationIsOpen] = useState(false);

  const openNavigation = (e) => {
    analytics({
      window,
      document,
      detail: getNavigationOpenDetail(e),
    });
    setNavigationIsOpen(true);
  };
  const closeNavigation = () => setNavigationIsOpen(false);

  const openSearch = (e) => {
    analytics({
      window,
      document,
      detail: getSearchOpenDetail(e),
    });
    setSearchIsOpen(true);
  };

  useEffect(() => {
    if (searchIsOpen || navigationIsOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => (document.body.style.overflow = 'unset');
  }, [searchIsOpen, navigationIsOpen]);

  const headerWhiteImage =
    tags?.some((t) => ['recipes', 'restaurants'].includes(t?.fields?.slug)) ??
    false;

  // TODO: clean up the header DD later
  return (
    <div
      id="navigation__wrapper"
      className={`${
        hasBackground
          ? ''
          : (isBlock || 'absolute top-0') +
            ` ${!headerWhiteImage && 'mb-12'} w-full h-20 bg-white`
      } dd-kr:bg-progressive-blue dd-en:bg-progressive-blue`}
    >
      <div className="relative z-40">
        <nav id="navigation" className="nav-menu">
          <div
            className={`absolute top-0 w-full px-7 md:px-10 ${
              hasBackground ? 'bg-transparent' : 'bg-white'
            }  dd-kr:bg-progressive-blue dd-en:bg-progressive-blue`}
          >
            <div className="grid grid-cols-5 sm:grid-cols-7 md:grid-cols-3 dd-kr:grid-cols-3 dd-kr:sm:grid-cols-3 dd-en:grid-cols-3 dd-en:sm:grid-cols-3  items-center justify-between mx-auto dd-kr:container dd-en:container dd-kr:px-0 dd-en:px-0 max-h-[90px] md:max-h-[80px]">
              <Button
                style={`nav-menu__btn cursor-pointer ${
                  hasBackground ? 'text-white' : 'text-black'
                } dd-kr:text-white dd-en:text-white`}
                onClick={openNavigation}
              >
                <Icon name="hamburger" height={24} width={24} />
              </Button>
              {hideLogo ? (
                <div className="grow h-[80px]"></div>
              ) : (
                <div className="nav-menu__logo cursor-pointer justify-self-center max-h-[90px] md:max-h-[80px]">
                  <CtaWrapper
                    page="/"
                    classNames="block dd-kr:hidden dd-en:hidden h-[90px] md:h-[80px]"
                  >
                    <WestholmeLogo
                      color={hasBackground ? '#fff' : '#000'}
                      width={125}
                      height={75}
                    />
                  </CtaWrapper>
                  <CtaWrapper
                    page="/"
                    classNames="hidden dd-kr:block dd-en:block"
                  >
                    <DDLogo width={51.05} height={60} />
                  </CtaWrapper>
                </div>
              )}
              <div className="flex flex-row gap-2 items-center justify-end col-span-3 sm:col-span-5 md:col-auto dd-kr:col-auto dd-kr:sm:col-auto dd-en:col-auto dd-en:sm:col-auto">
                <Button
                  style={`dd-kr:hidden dd-en:hidden nav-menu__signup flex items-center ${
                    hasBackground ? 'border-white' : 'border-acacia'
                  } bg-transparent border-solid border-[1px] h-[40px] px-5 cursor-pointer w-[100px] hover:bg-eucalyptus hover:border-acacia transition-all hover group`}
                >
                  <Text
                    style={`text-center font-semibold my-0 mx-auto ${
                      hasBackground ? 'text-white' : 'text-acacia'
                    } group-hover:text-acacia`}
                    tag="button"
                  >
                    Sign Up
                  </Text>
                </Button>
                <Button
                  style="nav-menu__search aaco-cta link-invert flex items-center md:bg-warm-grey dd-en:bg-actual-dd-gold dd-kr:bg-actual-dd-gold md:h-10 md:px-5 dd-en:rounded-[100px] dd-kr:rounded-[100px] cursor-pointer md:w-15  dd-en:py-[9px] dd-kr:py-[9px] dd-en:px-4 dd-kr:px-4 "
                  onClick={openSearch}
                >
                  <Icon
                    name="search"
                    height={14}
                    width={14}
                    className={`hidden md:block w-6 h-6 md:w-4 h:4 dd-kr:hidden dd-en:hidden text-acacia`}
                  />
                  <Text
                    style="hidden font-bold dd-kr:font-normal dd-en:font-normal dd-kr:block dd-en:block md:inline-flex text-acacia dd-en:text-white dd-kr:text-white md:ml-2.5 dd-kr:ml-0 dd-en:ml-0"
                    tag="button"
                  >
                    Explore
                  </Text>
                </Button>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <Search
        open={searchIsOpen}
        closeSearch={() => setSearchIsOpen(false)}
        tagGroupsWithTags={fields?.tagGroupsWithTags}
      />
      <NavigationContent
        open={navigationIsOpen}
        closeNavigation={closeNavigation}
        fields={fields?.links}
        assets={assets}
        slug={slug}
        socials={fields?.socialLinks}
        entries={entries}
      />
    </div>
  );
}

// @TODO: define real props for the Navigation based on it requirements
NavigationDefault.propTypes = {
  entries: PropTypes.array,
  fields: PropTypes.object,
  hasBackground: PropTypes.bool,
  tagGroupsWithTags: PropTypes.array,
  slug: PropTypes.string,
};

NavigationDefault.defaultProps = {
  hasBackground: false,
};

export default NavigationDefault;
